var _circle, _path, _path2, _path3;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgEditprofile = _ref => {
  let svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.1138,
    cy: 7,
    r: 4,
    stroke: "currentColor",
    strokeLinecap: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3896 15C13.011 14.5613 11.5034 14.4073 10.0204 14.5538C8.37993 14.7157 6.82849 15.2397 5.56425 16.0712C4.2999 16.9028 3.36751 18.0137 2.91551 19.2789C2.82261 19.5389 2.9581 19.825 3.21815 19.9179C3.47819 20.0108 3.76431 19.8754 3.85722 19.6153C4.22425 18.588 4.99892 17.64 6.11377 16.9067C7.22872 16.1734 8.62177 15.6967 10.1187 15.5489C10.6685 15.4946 11.2213 15.4858 11.7674 15.521C12.1227 15.1974 12.5952 15 13.1138 15L14.3896 15Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6249 15.125L14.8916 17.8583C14.697 18.0529 14.5997 18.1503 14.5327 18.2686C14.4657 18.3868 14.4323 18.5204 14.3656 18.7874L14.2854 19.1082C14.1951 19.4692 14.15 19.6498 14.2501 19.7499C14.3502 19.8499 14.5307 19.8048 14.8917 19.7146L15.2125 19.6344C15.4795 19.5676 15.6131 19.5342 15.7314 19.4672C15.8497 19.4003 15.947 19.3029 16.1416 19.1083L18.8749 16.375C19.2201 16.0298 19.2201 15.4702 18.8749 15.125C18.5297 14.7798 17.9701 14.7798 17.6249 15.125Z",
    stroke: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2083 15.125L18.8749 16.7917",
    stroke: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEditprofile, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/editprofile.33ace3e0.svg";
export { ForwardRef as ReactComponent };